import React, { Component } from 'react';
import BackNextButtons from './BackNextButtons';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Tooltips from '../includes/Tooltips';
import TextField from "@material-ui/core/TextField";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import axios from 'axios';
import FormLabel from '@material-ui/core/FormLabel';
import Switch from '@material-ui/core/Switch';
import $ from 'jquery';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

export default class GeneralInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        };
    }

    getBryteTui = () => {
        // let queryAddress = this.props.values.address;
        // let strtname = '';

        // if (queryAddress.includes("/")) {
        //     let addressArray = queryAddress.split("/")[1].split(",");
        //     strtname = addressArray[0];
        // } else if (queryAddress.includes(",")) {
        //     strtname = queryAddress.split(",")[0];
        // }

        // const res = {"success":true,"data":[{"Key":"PULSE_UFB_300","Title":"Everyday Fibre","Connection":"300\/100","Price":"$95","StandardRate":"$89","Details":"Perfect for households with a few people streaming at the same time, who enjoy watching Netflix, listening to music, and skyping.","AvgDownload":"300","BroadbandIcon":"Uploads\/Everyday-Fibre.png","Recommended":1,"SortOrder":1},{"Key":"PULSE_UFB_STARTER","Title":"Lite Fibre*","Connection":"50\/10","Price":"$60*","StandardRate":"61.74","Details":"For smaller households that use the internet for sending emails, reading the news and the occasional Facebook use.","AvgDownload":"50","BroadbandIcon":"Uploads\/Lite-Fibre.png","Recommended":0,"SortOrder":2},{"Key":"PULSE_UFB_MAX","Title":"Fibre Pro","Connection":"Max\/877","Price":"$111","StandardRate":"$96.52","Details":"Maximum speed for households who don\u2019t like to wait, perfect for if you have multiple people streaming or playing games online at the same time.","AvgDownload":"877","BroadbandIcon":"Uploads\/Fibre-Pro.png","Recommended":0,"SortOrder":3}],"error":{"title":"","message":""}};
        // let bryteData = res.data;

        // this.props.setBroadbandResults(bryteData);

        /* Temp Data */
        let queryAddress = this.props.values.address;
        let addressArray =''
        let strtname = ''
        let bryteData=''
        queryAddress.split(",");

        if (queryAddress.includes("/")) {
            addressArray = queryAddress.split("/");
           addressArray = addressArray[1].split(",");
           strtname = addressArray[0];
        } else if (queryAddress.includes(",")) {
            addressArray = queryAddress.split(",");
            strtname = addressArray[0];
        }

        //get tui from bryte api v1
        axios.post("/home/getBroadbandResult", {
            streetName:strtname
        }, {
            timeout: 100000
        }).then(res => {
            bryteData = res.data.data
            this.props.setBroadbandResults(bryteData)
        }).catch(function (error) {
            console.error(error);
        })
    }

    handleSubmit = () => {
        if (this.props.values.address !== '') {
            this.saveCustomerData();
        } else {
            this.props.alertEmptyAddress("Oops, something went wrong.", "Please re-enter your address/ICP to proceed");
            this.props.prevStep();
        }
    }

    componentDidMount = () => {
        if (!(this.props.values.userClass instanceof Array)) {
            this.props.setDefaultUserCode(this.props.values.userClass.UserClassCode);
        } else if (this.props.values.isAdditionalProperty === 'yes') {  
            this.props.setDefaultUserCode('002');
        }

        if (!(this.props.values.broadbandResult instanceof Array)) {
            this.axiosCancelSource = axios.CancelToken.source();
            this.getBryteTui();
        }
    }

    saveCustomerData = () => {
        this.props.nextStep();
        let formData = new FormData();

        let referrerValue = document.referrer || this.props.values.referrer;

        const currentUrl = window.location.href;
        if (currentUrl.includes("gclid")) {
            referrerValue = 'Adwords';
        }

        const searchParams = new URLSearchParams(window.location.search);
        const location = searchParams.get('location');
        referrerValue = location ? decodeURIComponent(location) : referrerValue || 'direct entry';

        const callbackFields = {
            firstName: this.props.values.firstName,
            mobilePhone: this.props.values.mobilePhone,
            email: this.props.values.email,
            icp: this.props.values.icp,
            address: this.props.values.address,
            promoCode: this.props.values.promoCode,
            applicationId: this.props.values.applicationId,
            csrfToken: this.props.values.csrfToken,
            referrer: referrerValue,
        }

        formData.append('application', JSON.stringify(callbackFields));

        axios.post("/home/handleApplicationForm", formData)
            .then(res => this.props.setApplicationId(res.data.data))
            .catch(error => console.log(error));
    }

    render() {

        return (
            <React.Fragment>
                <div className="initial-form">
                    <div className="flexContainer page-title-wrapper">
                        <h2 className="h2 primary" component="legend">{this.props.forms.FindMyPriceTitle}</h2>
                    </div>
                    <div className="flexContainer user-type-legend">
                        <FormLabel component="legend">Is this a bach / holiday home or additional property?</FormLabel>
                    </div>
                    <div className="flexContainer user-type-field user-type-field-first">
                        <FormLabel 
                            component="legend" 
                            className={this.props.values.isAdditionalProperty === 'yes' ? "" : "active"}
                        >
                            Yes
                        </FormLabel>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.props.values.isAdditionalProperty === 'no'}
                                    onChange={() => this.props.handleChange('isAdditionalProperty')({ target: { value: this.props.values.isAdditionalProperty === 'no' ? 'yes' : 'no' } })}
                                    color="primary"
                                />
                            }
                        />
                        <FormLabel 
                            component="legend"
                            className={this.props.values.isAdditionalProperty === 'no' ? "" : "active"}
                        >
                            No
                        </FormLabel>
                    </div>

                {(this.props.values.userClass instanceof Array && this.props.values.isAdditionalProperty === 'no') && 
                    <React.Fragment>
                        <div className="flexContainer user-type-legend">
                            <FormLabel component="legend">
                                Are you a Standard User or Low User? <Tooltips values={this.props.values}/>
                            </FormLabel>
                            &nbsp;
                        </div>
                        <div className="flexContainer user-type-field user-type-field-second">
                            <FormLabel 
                                component="legend" 
                                className={this.props.values.userClassCode === '001' ? "" : "active"}
                            >
                                Low User
                            </FormLabel>
                                <Switch
                                    checked={this.props.values.userClassCode === '002'}
                                    onChange={() => this.props.handleChange('userClassCode')({ target: { value: this.props.values.userClassCode === '002' ? '001' : '002' } })}
                                    color="primary"
                                /> 
                            <FormLabel 
                                component="legend" 
                                className={this.props.values.userClassCode === '002' ? "standard" : "standard active"}
                            >
                                Standard User
                            </FormLabel>
                        </div>
                    </React.Fragment>}
                    
                    <div className="flexContainer user-details">
                        <h4 className="h4 primary" component="legend">Your Details</h4>
                    </div>
                    
                    <ValidatorForm onSubmit={this.handleSubmit} className="OnlineSignUp_GeneralInfo" noValidate={true}>
                        {/* Form Container */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '16px' }} className="field-input-group">
                                {/* First Name Column */}
                                <div style={{ flex: '1 1 50%', padding: '0 8px 0 0' }}>
                                    <label htmlFor="firstName" style={{ display: 'block', marginBottom: '4px' }}>First Name*</label>
                                    <TextValidator
                                        required
                                        validators={['required', 'matchRegexp:[^ ]']}
                                        errorMessages={['Please enter your first name', 'Please enter your first name']}
                                        name="firstName"
                                        variant="outlined"
                                        margin="normal"
                                        value={this.props.values.firstName}
                                        onChange={this.props.handleChange('firstName')}
                                        inputProps={{ 'aria-label': 'First Name' }} // Accessibility
                                        style={{ width: '100%' }} // Adjust as needed
                                    />
                                </div>

                                {/* Mobile Phone Column */}
                                <div style={{ flex: '1 1 50%', padding: '0 8px 0 0' }}>
                                    <label htmlFor="mobilePhone" style={{ display: 'block', marginBottom: '4px' }}>Mobile Phone*</label>
                                    <TextValidator
                                        required
                                        validators={['required']}
                                        errorMessages={['Please enter your mobile number']}
                                        type="number"
                                        name="mobilePhone"
                                        variant="outlined"
                                        margin="normal"
                                        value={this.props.values.mobilePhone}
                                        onChange={this.props.handleChange('mobilePhone')}
                                        inputProps={{ 'aria-label': 'Mobile Phone' }} // Accessibility
                                        style={{ width: '100%' }} // Adjust as needed
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '16px' }} className="field-input-group">
                                {/* Email Address Column */}
                                <div style={{ flex: '1 1 50%', padding: '0 8px 0 0' }}>
                                    <label htmlFor="email" style={{ display: 'block', marginBottom: '4px' }}>Email Address*</label>
                                    <TextValidator
                                        required
                                        validators={['required', 'isEmail']}
                                        name="email"
                                        variant="outlined"
                                        margin="normal"
                                        value={this.props.values.email.replace(/ /g, '').toLowerCase()}
                                        onChange={this.props.handleChange('email')}
                                        errorMessages={['This field is required', 'Email is not valid']}
                                        inputProps={{ 'aria-label': 'Email Address' }} // Accessibility
                                        style={{ width: '100%' }} // Adjust as needed
                                    />
                                </div>

                                {/* Promo Code Column */}
                                <div style={{ flex: '1 1 50%', padding: '0 8px 0 0' }}>
                                    <label htmlFor="promoCode" style={{ display: 'block', marginBottom: '4px' }}>Promo code (if applicable)</label>
                                    <TextField
                                        name="promoCode"
                                        variant="outlined"
                                        margin="normal"
                                        value={this.props.values.promoCode}
                                        onChange={this.props.handleChange('promoCode')}
                                        inputProps={{ 'aria-label': 'Promo Code' }} // Accessibility
                                        style={{ width: '100%' }} // Adjust as needed
                                    />
                                </div>
                            </div>
                        </div>

                        <p className="footnotes__text__description">
                            Note: if you do not complete the sign up, our team may get in contact with you to see if we can assist you.
                        </p>
                        
                        <BackNextButtons
                            values={this.props.values}
                            id="GeneralInfo"
                            clearState={this.props.clearState}
                            nextStep={this.props.nextStep}
                            prevStep={this.props.prevStep}
                        />
                    </ValidatorForm>
                </div>
            </React.Fragment>
        );
    }
}
